/**
 * PMO #23510 / #3062 (PAGOS) — el SUPER_ADMIN que cancela una suscripción ajena dice POR QUÉ, y de eso depende cuándo
 * corta (Términos 14.1 y 14.3, visto de THEMIS): una causa grave o un fraude corta ya; lo que el cliente pidió respeta el
 * ciclo que ya pagó. El API responde 400 `MOTIVO_REQUERIDO` si falta o no es uno de estos dos: no hay un valor por defecto
 * silencioso. Los dos clientes de admin que cancelan (`admin-subscriptions-api`, `plans-api`) comparten esta lista.
 */
export const MOTIVOS_DE_CANCELACION_ADMIN = ['causa_grave', 'a_pedido_del_cliente'] as const;

export type MotivoDeCancelacionAdmin = (typeof MOTIVOS_DE_CANCELACION_ADMIN)[number];

/**
 * Antes de mandar el PATCH: un llamador que se olvide del motivo (o lo escriba mal) falla aquí, sin pedir nada al API.
 * Es una barrera para quien programa, no un texto para el cliente.
 */
export function exigirMotivoDeCancelacion(motivo: unknown): MotivoDeCancelacionAdmin {
  if (!MOTIVOS_DE_CANCELACION_ADMIN.includes(motivo as MotivoDeCancelacionAdmin)) {
    throw new Error(`Falta el motivo de la cancelación (${MOTIVOS_DE_CANCELACION_ADMIN.join(' | ')})`);
  }
  return motivo as MotivoDeCancelacionAdmin;
}
